import React from 'react';
import { FiPause, FiPlay, FiRotateCcw, FiRotateCw, FiX } from 'react-icons/fi';
import { SPEED_OPTIONS, useAudioPlayer } from '../audio/AudioPlayerContext';
import { formatDuration } from '../utils/format';
import './GlobalPlayer.css';

// Persistent bottom player. Rendered by the shell so playback survives navigation.
export default function GlobalPlayer() {
  const { current, isPlaying, isLoading, position, duration, playbackRate, toggle, seekTo, seekBy, setPlaybackRate, stop } =
    useAudioPlayer();

  if (!current) return null;

  const pct = duration > 0 ? (position / duration) * 100 : 0;

  const cycleSpeed = () => {
    const idx = SPEED_OPTIONS.indexOf(playbackRate);
    setPlaybackRate(SPEED_OPTIONS[(idx + 1) % SPEED_OPTIONS.length]);
  };

  const formatEmoji = current.format === 'audiobook' ? '📖' : current.format === 'tts' ? '🔊' : '🎙️';

  return (
    <div className="gplayer" role="region" aria-label="Audio player">
      <div className="gplayer__info">
        <span className="gplayer__emoji" aria-hidden>
          {formatEmoji}
        </span>
        <div className="gplayer__meta">
          <span className="gplayer__title" title={current.title}>
            {current.title}
          </span>
          <span className="gplayer__time">
            {formatDuration(position)} / {formatDuration(duration || current.durationSeconds)}
          </span>
        </div>
      </div>

      <div className="gplayer__controls">
        <button className="gplayer__icon" onClick={() => seekBy(-15)} title="Back 15s" aria-label="Back 15 seconds">
          <FiRotateCcw />
        </button>
        <button className="gplayer__play" onClick={toggle} aria-label={isPlaying ? 'Pause' : 'Play'}>
          {isLoading ? <span className="spinner spinner--sm" /> : isPlaying ? <FiPause /> : <FiPlay />}
        </button>
        <button className="gplayer__icon" onClick={() => seekBy(15)} title="Forward 15s" aria-label="Forward 15 seconds">
          <FiRotateCw />
        </button>
      </div>

      <div className="gplayer__track">
        <input
          className="gplayer__scrub"
          type="range"
          min={0}
          max={duration || 0}
          value={position}
          onChange={(e) => seekTo(Number(e.target.value))}
          aria-label="Seek"
        />
        <div className="gplayer__bar">
          <div className="gplayer__fill" style={{ width: `${pct}%` }} />
        </div>
      </div>

      <div className="gplayer__right">
        <button className="btn btn--ghost btn--sm" onClick={cycleSpeed} title="Playback speed">
          {playbackRate}x
        </button>
        <button className="gplayer__icon" onClick={stop} title="Close player" aria-label="Close player">
          <FiX />
        </button>
      </div>
    </div>
  );
}
